const { REACT_APP_VIDEO_SDK_URL } = process.env

export const buildMeetUrl = ({
    meetVersion = 0,
    baseUrl,
    topic,
    zoomToken,
    widgetToken,
    name,
    courseName,
    _classId,
    algorithmId,
}: {
    meetVersion?: number
    /** Base URL que manda el backend cuando el curso tiene prompt-building (IA) activo. */
    baseUrl?: string | null
    topic: string
    zoomToken: string
    widgetToken: string
    name: string
    courseName: string
    _classId: string
    algorithmId: string
}) => {
    // El backend es la unica fuente de verdad del destino IA: si manda baseUrl, gana.
    // Si no (flag apagado o backend sin deployar), el switch de siempre por sdkVersion.
    const base =
        baseUrl || (meetVersion === 0 ? REACT_APP_VIDEO_SDK_URL : REACT_APP_VIDEO_SDK_URL.replace('video.', 'meet.'))

    return `${base}/meeting?${new URLSearchParams({
        topic,
        zoomToken,
        widgetToken,
        name,
        courseName,
        _classId,
        _algorithmId: algorithmId,
    }).toString()}`
}
